export default {"src":"/_next/static/media/pepsico_black.bb79ab6c.svg","height":14,"width":100,"blurWidth":0,"blurHeight":0};